export default __webpack_public_path__ + "static/media/promotional-image.d3e59797.png";